module.exports = __webpack_public_path__ + "static/media/ly.b4dd5c8a.svg";